export const DELIVERY_REJECTION_EXPORT_ID = "delivery-rejection";
export const DELIVERY_REJECTION_TITLE = "Entregas Rechazadas";

export const LOCALIZED_PROPERTIES = {
  code: "Codigo_Ruta",
  subRoute: "Ruta",
  trip:"Viaje",
  user: "Usuario",
  serials: "Nro Doc",
  date: "Fecha",
  shipToExternalKey: "Cod.Receptor",
  shipToName: "Receptor",
  soldToExternalKey:"Cod.Pagador",
  soldToName:"Pagador",
  materialCode: "Codigo_Material",
  materialName: "Material",
  rejectedQuantitiesOnDelivery: "Razones de rechazo",
  baseUnitOfMeasureCode: "UMB",
  soldQuantity: "Cantidad",
  pararellUnitOfMeasureCode: "UMP",
  pararellQuantity: "Cantidad UMP",
  unitPrice: "Precio",
  subTotal: "Subtotal",
  total: "Total",
  status: "Estado",
  rejectedQuantitiesReasons: "Razones de Rechazo",
};
